import { Component, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { IonApp, IonAvatar, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonNav, IonRouterOutlet, IonToolbar, MenuController, ModalController, NavController } from '@ionic/angular/standalone';
import { ApiService } from './api.service';
import { IconService } from './icon.service';
import { Group, Training } from './app.types';
import { CommonModule, Location } from '@angular/common';
import { TrainingPage } from './training/training.page';
import { StatusBar, Style } from '@capacitor/status-bar';
import { PasswordResetPage } from './password-reset/password-reset.page';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { environment } from 'src/environments/environment';
import { InvitePage } from './invite/invite.page';
import { AuthService, TempoUser } from './auth.service';
import { Subscription } from 'rxjs';
import { addIcons } from 'ionicons';
import { checkmark, closeOutline, fingerPrintOutline, shieldCheckmarkOutline, logOutOutline, personRemoveOutline, qrCodeOutline, lockClosedOutline, personCircleOutline } from 'ionicons/icons';
import { AuthNavPage } from './auth-nav/auth-nav.page';
import { AuthComponent } from './components/auth/auth.component';
import { Meta, Title } from '@angular/platform-browser';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';
import { ConnectivityService } from './connectivity.service';
import { AppLinkService } from './app-link.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    standalone: true,
    providers: [IonNav],
    imports: [
        CommonModule,
        IonApp,
        IonMenu,
        IonHeader,
        IonToolbar,
        IonAvatar,
        IonLabel,
        IonImg,
        IonButton,
        IonButtons,
        IonIcon,
        IonContent,
        IonList,
        IonItem,
        IonListHeader,
        IonFooter,
        IonRouterOutlet
    ]
})
export class AppComponent implements OnInit, OnDestroy {

    appVersion = ""
    appBuild = ""
    env = ""

    user?: TempoUser
    authSub: Subscription

    private auth = inject(AuthService)
    private api = inject(ApiService)
    private connectivity = inject(ConnectivityService)
    private appLink = inject(AppLinkService)

    
    constructor(
        public icon: IconService,
        private modalController: ModalController,
        private router: Router,
        private readonly zone: NgZone,
        private location: Location,
        private menuController: MenuController,
        private title: Title,
        private meta: Meta,
        private navController: NavController,
        
    ) {
        addIcons({closeOutline,qrCodeOutline,shieldCheckmarkOutline,lockClosedOutline,personCircleOutline,checkmark,fingerPrintOutline,logOutOutline,personRemoveOutline});
    }


    ngOnDestroy() {
        this.authSub.unsubscribe()
    }

    appIsOnline = true


    async ngOnInit() {

        
        await this.connectivity.init()
        this.connectivity.startInternetMonitor(15000)


        const darkModeOn = window.matchMedia('(prefers-color-scheme: dark)').matches
        if (darkModeOn) {
            const element = document.querySelector('html')
            element.classList.toggle('darkTheme')
        }

        if (Capacitor.getPlatform() === "web") {


            //

            const path = this.location.path().split("/")
            console.log("Running on WEB, path comps", path.length)

            // if (path.length >= 3 && path.includes("home")) {
            //     console.log("Requesting home...")
            //     this.navController.navigateRoot("appstore")

            // }

            if (path.length >= 3 && path.includes("embed")) {
                console.log("Requesting embed on web", path)

                const mcheck = await this.modalController.getTop()
                if (!!mcheck) {
                    if (mcheck.component === AuthComponent) {
                        console.log("Dismissing auth modal")
                        await mcheck.dismiss()
                    } else {
                        console.log("No auth modal to dismiss...")
                    }

                }

                console.log("Presenting embed training")
                const res = await this.setupTraining(Number(path[2]))
                if (!res.t) {
                    this.api.presentAlert("Errore", "Questo contenuto non esiste o è stato eliminato.")
                    return
                }
                const modal = await this.modalController.create({
                    component: TrainingPage,
                    componentProps: {
                        //tid: Number(path[2])
                        t: res.t,
                        embGroup: res.embGroup
                    }
                })
                modal.present()
            }


            // if (path.length >= 3 && path[1] == "verify") {

            //     this.api.checkVerifyCode(path[2]).then((vres) => {
            //         if (vres.valid) {
            //             this.router.navigate(["verify-success"])
            //         } else {
            //             this.api.presentAlert("Errore", "Questo link non è più valido o è stato già utilizzato.")
            //         }
            //     })
            // }

            /*
            if (!environment.production) {
              console.log("Non in production!")
              this.api.initApi()
              this.icon.initIconService()
              this.initializeApp()
            }
            */





        } else {

            await StatusBar.setStyle({
                style: Style.Default
            })

            if (Capacitor.getPlatform() == "android") {
                await StatusBar.setOverlaysWebView({
                    overlay: false
                })
            }


            // this.api.initApi()
            // this.icon.initIconService()
            this.getAppInfo()
            this.initializeApp()
            this.authSub = this.auth.authStateChange$.subscribe((u) => {
                console.log("authStateChange on AppComponent")
                if (u && u.selectedGroup) {
                    console.log("authStateChange on AppComponent has selected group (no action, commented)")
                    this.user = u
                } else {
                    console.log("authStateChange on AppComponent NO selected group")
                    this.user = undefined
                }
            })
        }





        //this.icon.initIconService()

        //this.initializeApp()
        //this.api.initApi()

        // if (isPlatformServer(this.platformId)) {
        //     console.log('Running on the server');
        // } else {
        //     console.log('Running on the browser');
        // }

        //const ip = await this.api.getMyIp()
        //const cires = await this.api.clientInfo()
        // this.api.user_agent = cires.user_agent
        // this.api.client_ip = ip


    }

    

    async setupTraining(tid: number) {
        console.log("setupTraining", tid)
        const tres = await this.api.getSingleTraining(tid)
        if (tres.trainings.length > 0) {
            const t = tres.trainings[0]
            const tquests = await this.api.getTrainingQuest(t.tid)
            t.questions = tquests.questions

            const gres = await this.api.groupById(t.gid)
            const embGroup = gres.group

            console.log("setupTraining", t.title, embGroup.name)



            if (!Capacitor.isNativePlatform()) {
                this.updateSeo(t)
            }

            return { t: t, embGroup: embGroup }

        }

        return null
    }

    updateSeo(t: Training) {
        this.title.setTitle(t.title)
        this.meta.updateTag({
            name: "description",
            content: t.description
        })

        const mtags = [

            {
                property: "og:title",
                content: t.title
            },
            {
                property: "og:description",
                content: t.description
            },
            {
                property: "og:image",
                content: t.cover
            },
            {
                property: "og:url",
                content: "https://app.aitempo.online/embed/" + t.tid
            },
            {
                property: "og:type",
                content: "website"
            },
            {
                property: "og:site_name",
                content: "aiTempo"
            },
            {
                property: "twitter:card",
                content: "summary"
            },
            {
                property: "twitter:title",
                content: t.title
            },
            {
                property: "twitter:description",
                content: t.description
            },
            {
                property: "twitter:image",
                content: t.cover
            },
            {
                property: "twitter:url",
                content: "https://app.aitempo.online/embed/" + t.tid
            }
        ]
        for (const mt of mtags) {
            this.meta.updateTag({
                name: mt.property,
                content: mt.content
            })
        }
    }

    async initializeApp() {



        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {

            this.zone.run(async () => {
                if (!environment.production) {
                    //this.api.presentAlert("URL", event.url)
                }

                console.log("EVENT URL:", event.url)
                await this.appLink.handleUrl(event.url)
            })


        });

        App.addListener("appStateChange", (state) => {
            this.zone.run(async () => {
                console.log("appStateChange", state)
                if (this.auth.userExists()) {
                    try {
                        if (!state.isActive) {
                            await this.auth.persistSelectedGroup()
                            return
                        }

                        const fingerprintApplied = await this.auth.syncFingerprintGroupForCurrentUser()
                        if (!fingerprintApplied) {
                            await this.auth.applyPendingEmbedGroupForCurrentUser()
                        }
                    } catch (error) {
                        console.log("appStateChange group sync error", error)
                    }
                }
            })
        })


        // this.router.events.subscribe(event => {
        //     if (event instanceof NavigationStart) {
        //         const url = event.url;
        //         console.log("NavigationStart", url)
        //     }
        // })
    }

    hiddenUid() {
        if(!this.user) return ""
        this.auth.hiddenUid(this.user.uid)
      }

    async showProfile() {
        await this.menuController.close()
        this.navController.navigateForward("/profile")
    }

    async showGroupPrivacy() {
        console.log("showGroupPrivacy")
        const modal = await this.modalController.create({
            component: AuthNavPage,
            componentProps: {
                group: this.user.selectedGroup,
                firebaseUid: this.user.uid,
                fromMenu: true
            }
        })
        modal.present()
    }

    

    async getAppInfo() {

        if (Capacitor.getPlatform() != "web") {
            const info = await App.getInfo()
            this.appVersion = info.name + " v" + info.version
            this.appBuild = "Build " + info.build
            this.env = environment.production ? "" : "- Test mode"
        }

    }

    async showPrivacy() {
        //await Browser.open({ url: 'https://aitempo.online/privacy.pdf' })
        this.menuController.close()
        this.router.navigate(["privacy"])
    }
    async showTerms() {
        //await Browser.open({ url: 'https://aitempo.online/termini.pdf' })
        this.menuController.close()
        this.router.navigate(["terms"])
    }

    async unlockGroup() {
        //await this.nav.navigateRoot("/invite")
        const modal = await this.modalController.create({
            component: InvitePage,
            componentProps: {
                isModal: true,
                isMenu: true
            }
        })
        //
        modal.present()
    }


    async qrcodeReader() {
        this.menuController.close()
        //this.router.navigate(["qr-scanner"])

        const res = await CapacitorBarcodeScanner.scanBarcode({
            scanInstructions: "Inquadra il QR Code",
            hint: CapacitorBarcodeScannerTypeHint.QR_CODE
        })

        
        if (res.ScanResult.includes("https://app.aitempo.online/service/")) {
            console.log("res.ScanResult", res.ScanResult); // log the raw scanned content

            const slugParts = res.ScanResult.split("/")
            console.log(slugParts)
            

            let route = res.ScanResult.replace("https://app.aitempo.online", "").split("?")[0]
            this.router.navigate([route])
        }
    }

    async selectGroup(g: Group) {
        if (g.gid === this.user.selectedGroup.gid) return
        await this.auth.setSelectedGroup(g, true)
        await this.menuController.close()
    }

    



}
